import React from 'react';
import {inject, observer} from 'mobx-react';
import FlowItem from './components/FlowItem';
const flowItemsTitles = ['Data Annotation', 'Quality Control', 'Pre-training Summary', 'Training Model'];

const ClassificationFlow = (props) => {
    const {classificationFlowIndex} = props;
    const checkClass = (index) => {
        if (classificationFlowIndex === index) {
            return 'active';
        } else if (classificationFlowIndex > index) {
            return 'pass';
        }

        return 'inactive';
    };

    return (
        <div className='classification-flow-container'>
            {flowItemsTitles.map((title, index) => <FlowItem key={title} className={checkClass(index)} title={title} isLast={index === flowItemsTitles.length - 1}/>)}
        </div>
    );
};

export default inject('siaStore')(observer(ClassificationFlow));
